import { watch } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useSiteBrand } from './useSiteBrand.js';
import { applySiteBrandHead } from '../utils/siteBrandHead.js';

/**
 * Sets document.title and meta description from published site brand.
 */
export function useDocumentTitle() {
  const route = useRoute();
  const { t } = useI18n();
  const { siteName, siteSlogan } = useSiteBrand();

  watch(
    [() => route.meta?.titleKey, siteName, siteSlogan, () => route.fullPath],
    () => {
      const name = siteName.value;
      const pageKey = route.meta?.titleKey;
      const page = pageKey ? t(pageKey) : '';
      applySiteBrandHead({
        siteName: name,
        siteSlogan: siteSlogan.value,
        pageTitle: page
      });
    },
    { immediate: true }
  );
}
